import React from "react"
import { createRoot } from "react-dom/client"
import App from "./view/app"
import "./index.css"
import "bootstrap/dist/css/bootstrap.min.css"
import "typeface-quicksand"
import "typeface-fira-sans"
import { Provider } from "react-redux"
import store from "./store/index"
import { setStore } from "./store/api/offline"
import { setAuthorizationToken } from "./store/api"
import { NetworkStatusProvider } from "./providers/NetworkStatusProvider"
import ErrorBoundary from "./components/layout/ErrorBoundary"

import { i18n } from "@lingui/core"
import { I18nProvider } from "@lingui/react"
import { defaultLocale, dynamiclyActivate } from "./i18n"

const I18nApp = () => {
  React.useEffect(() => {
    // With this method we dynamically load the catalogs
    const savedLocale = localStorage.getItem("lang") || defaultLocale
    dynamiclyActivate(savedLocale)
  }, [])

  return (
    <ErrorBoundary store={store}>
      <I18nProvider i18n={i18n}>
        <Provider store={store}>
          <NetworkStatusProvider>
            <App />
          </NetworkStatusProvider>
        </Provider>
      </I18nProvider>
    </ErrorBoundary>
  )
}
setStore(store)
setAuthorizationToken(localStorage.getItem("token"), localStorage.getItem("tokenBC"))
const container = document.getElementById("app")
const root = createRoot(container)
root.render(
  <React.StrictMode>
    <I18nApp />
  </React.StrictMode>,
)

window.addEventListener('beforeunload', () => {
  try {
    if (worker) {
      worker.terminate();
      console.log('Worker terminated on page unload.');
    }
  } catch(err) {
    console.error("Error: No web worker")
  }
});
if (window.Cypress) {
  window.store = store
}
